import moment from "moment";
import { Field, FieldRenderProps, useForm, useFormState } from "react-final-form";
import { DatePicker, TextInput } from "@pickit/pickit-components";
import { DATE_FORMATS } from "utils/constants";
import { InvoiceDataMXProps } from "./types";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const InvoiceDataMX = ({
  isFormEnabled,
  minDate,
  testId,
}: InvoiceDataMXProps) => {
  const { t } = useTranslation();
  const form = useForm();
  const formState = useFormState();
  const [prevInvoiceNumber, setPrevInvoiceNumber] = useState("");

  useEffect(() => {
    setPrevInvoiceNumber(formState.values.invoiceNumber);
  }, [formState.values.invoiceNumber]);

  return (
    <>
      <Field name="emisionDate">
        {({ input, meta }: FieldRenderProps<string>) => (
          <div>
            <DatePicker
              input={input}
              meta={meta}
              singleSelection
              outputFormat={DATE_FORMATS.shortDate}
              minDate={minDate as unknown as string}
              maxDate={moment() as unknown as string}
              disabled={!isFormEnabled}
              placeholder={t("invoice:dateOfIssuePlaceholder")}
              label={t("invoice:dateOfIssueLabel")}
              language="es"
              testId={`${testId}-field-emision-date`}
            />
          </div>
        )}
      </Field>

      <div className="invoice-type-mx">
        <Field
          label={t("invoice:voucherTypeLabel")}
          disabled
          type="text"
          placeholder={t("invoice:voucherTypePlaceholder")}
          name="invoiceType.name"
          className="Admin-Pickers-input"
          component={TextInput}
          testId={`${testId}-field-voucher-type`}
        />
      </div>
      <Field name="invoiceNumber">
        {({ input, meta }: FieldRenderProps<string>) => (
          <TextInput
            input={{
              ...input,
              onChange: (value: unknown) => {
                input.onChange(value);
                if (prevInvoiceNumber?.slice(-1) !== "-") {
                  form.mutators.setMXInvoice?.(value);
                }
              },
            }}
            meta={meta}
            disabled={!isFormEnabled}
            label={t("invoice:invoiceNumberLabel")}
            className="Admin-Pickers-input"
            placeholder={t("invoice:invoiceNumberPlaceholder")}
            maxLength={36}
            testId={`${testId}-field-invoice-number`}
          />
        )}
      </Field>
    </>
  );
};

export default InvoiceDataMX;
